import callFunction, {
  keycloakInit,
    logout,
  } from "../../../public/common/vue/api/leanbot_js_api";
  import $ from "jquery";
  import WebsocketLeanbot from "../../../public/common/vue/api/leanbot.websocket";
  import * as paho_mqtt from "paho-mqtt";
  import Appbar from "../components/appbar/appbar.vue";
import { defineComponent } from "vue";
import axios from "axios";
import {i18n} from '@/app-i18n'
export default defineComponent({
    data() {
        return {
          urlmqtt: "",
          portmqtt: "",
          topicmqtt: "",
          urlgateway: "",
          methodgateway: "",
          lang: "en",
          usernamelogin: "",
          greet: i18n.global.t("message.hello")
         
        };
      },
      components:{
        Appbar
      },
      async mounted() {
        await keycloakInit.catch(console.error);
        this.usernamelogin = sessionStorage.getItem("USERNAME");
        if (sessionStorage.getItem("lang") == "vi") {
          this.lang = "vi";
        } else {
          this.lang = "en";
        }
        
        
      },
      methods: {
        
        gotoConnectDevice(){
          window.location.href = '/connectdevice'
        },
        logout1() {
          logout();
        },
        
      }
});